let { nothing, CustomHTMLElement, createTemplateFn, translation, utils } = lithtml;
const tag     = 'lithtml-parser';
const version = '0.9.20';

/**
 * Lithtml parser that takes a template and dynamically 'htmlifies' it.
 */
class LitHtmlParser extends CustomHTMLElement {
    static get tag()     { return tag }
    static get version() { return version }

    /** Make sure changing the template, context, ... trigger a rerender */
    static get observedAttributes() { return ['template-ref', 'use-shadow-root', 'default-context', 'wait-for-context', 'default-template', 'context-ref', 'translation-ref'] }
    static get observedProperties() { return ['context', 'template', 'removeOnRendered', 'translation']; }

    /**
     * Constructor
     */
    constructor() {
        super(LitHtmlParser, { useShadowRoot: false });

        let self = this;

        self._ad = self._ad.bind(self);
        self._ae      = translation.init();
        self._af = self._ag();
    }

    /**
     *
     * @returns {object} the object containing obeserved property BL
     */
    _ag() {
        let self = this;

        return {
            defaultTemplate: (newValue) => !self.template && (self.template = newValue),
            defaultContext : (newValue) => !self.context  && (self.context  = newValue),
            template       : (newValue) => newValue       && (self._ah  = createTemplateFn(newValue.trim(), { thisContext: self, contextParams: ['context', '$', '$root', '$parent', '$this', 't']})),
            translation    : (newValue) => newValue       && (self._ae.setTranslation(newValue)),
            useShadowRoot  : (newValue) => self.options.useShadowRoot = newValue,
            context        : (newValue) => self.getAttribute('observed-properties')?.split(',').forEach (propName => utils.defineProperty(newValue, propName, newValue[propName], _ => self.requestRender('observedprop'))),
            templateRef    : (newValue) => {
                if (!newValue) {
                    return;
                }

                // If the template tag is defined before the lithtml-parser tag, then the element is found here...
                self._ai(newValue);

                // .. but if defined later in the html DOM we need to do an async callback to retrieve the element
                !self.template && setZeroTimeout(() => self._ai(newValue));
            },
            contextRef: (newValue) => {
                if (!newValue || self.context) {
                    return;
                }

                // Check if the data is located in a script tag...
                if (newValue[0] === '#') {
                    self._aj(newValue.substring(1), data => self.context = data);
                    !self.context && setZeroTimeout(() => self._aj(newValue.substring(1), data => self.context = data));

                    return;
                }
                // .. or inside a global object
                self._ak(newValue, data => self.context = data);
                !self.context && setZeroTimeout(() => !self.context && self._ak(newValue, data => self.context = data));
            },
            translationRef: (newValue) => {
                if (!newValue || self.translation) {
                    return;
                }

                // Check if the translation is located in a script tag...
                if (newValue[0] === '#') {
                    self._aj(newValue.substring(1), data => self.translation = data);
                    !self.context && setZeroTimeout(() => self._aj(newValue.substring(1), data => self.translation = data));

                    return;
                }
                // .. or inside a global object
                self._ak(newValue, data => self.translation = data);
                !self.translation && setZeroTimeout(() => self._ak(newValue, data => self.translation = data));
            }
        }
    }

    /** Called when destroy has been called on the element, so we do some cleanup */
    onDestroy () {
        let self = this;

        self._ae =
        self._ah    =
        self.$parent    =
        self.$root      = null;
    }

    /** Called each time the custom element is (re-)connected to the DOM */
    onConnected() {
        this._al();
// TODO: if nodeType===8 and .data ==='end', if next is 'start', then remove the nodes before (from initial 'start')
//        for(let e of this.childNodes)
//         console.log(this.id, e.nodeType, e.data)
    }

    /** Called each time the custom element is moved around in the DOM */
    onMoved() {
        this._al();
    }

    /** Called when the custom element is disconnected from the DOM */
    onDisconnected() {
        let self = this;

        self.$parent?.removeEventListener('rendered', self._ad);
        self.$parent = null;
        self.$root   = null;
    }

    /**
     * Called when an observed property (or attribute) changes value
     * @param {string} name the name of the property
     * @param {string} oldValue the old value of the property
     * @param {string} newValue the new value of the property
     */
     onPropertyChanged(name, oldValue, newValue) {
        this._af[name]?.(newValue, oldValue);
    }

//onFirstRender() {
//    let self = this;
//    console.log('onFirstRender', self.id)
//    if (!self.template) {
//        console.log('onFirstRender', self.id, !!self.template, self.childNodes.length)
//        self._am();
//        console.log('onFirstRender--', self.id, !!self.template, self.childNodes.length)
//    }
//}

    /** Render the template */
    render() {
        let self = this;

        if (!(self.template || self.templateRef)) {
            queueMicrotask(_ => {
                self._am();

                if (self.template || self.templateRef) {
                    return;
                }

                window.setZeroTimeout(() => self._am(true));
            });

            return nothing;
        }

        if (!self._ah) {
            return nothing;
        }

        if (self.waitForContext && !self.context) {
            return nothing;
        }

        let context = self.context || {};

        return self._ah({context, $: context, $root: self.$root, $parent: self.$parent, $this: self, t: self._ae});
    }

    /**
     *
     * @param {string} templateRef the template id
     */
    _ai(templateRef) {
        let el = document.getElementById(templateRef);

        if (el) {
            this.template = el.innerText;
        }
    }

    /**
     *
     * @param {string} elementId  the element id
     * @param {function} cb the callback
     */
     _aj(elementId, cb) {
        let el = document.getElementById(elementId);

        if (!el) {
            return;
        }

        // Make sure that data attached to the script tag is singleton
        let data = el.jsonData || (el.jsonData = JSON.parse(el.innerText));

        data && cb(data);
    }

    /**
     *
     * @param {string} propertyName the name of the property
     * @param {function} cb the callback
     * @param {object} [obj=window] the object in which propertyName is to be searched for
     */
    _ak(propertyName, cb, obj = window) {
        let data = propertyName.split('.').reduce((obj, prop) => obj ? obj[prop] || null : null, obj);

        data && cb(data);
    }

    /**
     *
     * @param {boolean} async
     * @returns
     */
    _am (async) {
        var self = this;

        if (self.template || self.templateRef) {
            return;
        }

        for (let node of self.childNodes) {
            if (node.localName === 'script') {
                node.remove();
                self.template = node.innerText;
                break;
            }
        }
    }

    /**
     * Called when a render has happend, we use it to trigger a rendered event that
     * any child lithtml-parser's can listen to and rerender themself.
     */
    onRendered() {
        let self = this;

        self.dispatchEvent(new CustomEvent('rendered', { bubbles: false }));

        // Support removing the element itself after beeing rendered, making sure the
        // elements content is still shown. May be used to make styling the resulting
        // html easier or to use a little lesss resources (since the custom element
        // is destoyed and frees context etc.)
        // TODO: Take defaultContext into consideration? That is, wait to remove until self.context !== self.defaultContext? The same with default template?
        if ((self.$attribs.removeOnRendered || self.removeOnRendered) && self.context && self._ah) {
            queueMicrotask(() => {
                self.replaceWith(...(self.shadowRoot || self).childNodes);
                self.destroy();
            });
        }
    }

    /**
     * Finds the parent and root parsers
     */
    _al() {
        let self   = this;
        let parent = self.parentElement;

        while (parent != null) {
            if (parent.localName.startsWith('lithtml-parser')) {
                break;
            }

            parent = parent.parentElement;
        }

        if (parent && parent !== self.$parent) {
            self.$parent?.removeEventListener('rendered', self._ad);
            parent.addEventListener('rendered', self._ad);
        }

        self.$parent = parent;
        self.$root   = (parent?.$root) || self;
    }

    /**
     * Event called each time the parent lithtml-parser has been rendered
     */
    _ad() {
        this.requestRender('parentUpdated');
    }
}

// Define the new web component
if (!window.customElements.get(tag)) {
    window.customElements.define(tag, LitHtmlParser);
}

// TODO: -on onDisconnect set _an to null and reattach on onConnect